import { Component, OnInit } from '@angular/core';
import { AuthService} from '../auth/auth.services';
import {AngularFireAuth} from 'angularfire2/auth';
import { Router} from '@angular/router';
//import { AuthService} from  '../auth/auth.services';
@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  constructor(private fireAuth:AngularFireAuth,private authServic:AuthService,private router:Router) { }

  ngOnInit() {


  }

  goTrail(path){

  this.authServic.initAuthentication(path);
    
  };
onHome(){
  
                            this.router.navigate(['/']);
}

}
